import { Input } from "simplydo/react/ui/input";

import { FieldProps } from "./FieldProps";

const ShortText = ({
  field,
  fieldValue = "",
  updateIdea,
  isEditing,
}: FieldProps) => {
  const textValue = typeof fieldValue === "string" ? fieldValue : "";
  if (!isEditing) return <span>{textValue}</span>;
  return (
    <div>
      <Input
        fluid
        value={textValue}
        onChange={(e) => updateIdea(e.target.value, ["templated", field.id])}
        readOnly={!isEditing}
      />
    </div>
  );
};

export default ShortText;
